import { PAGE_KEY } from '../constants';

const es = {
  [PAGE_KEY]: {
    TITLE_1: 'Hola,',
    TITLE_2: '¿Qué necesitas hacer hoy?',
    HEADER_V2_DESCRIPTION:
      'En este espacio, encontrarás las principales herramientas para tu crecimiento dentro de la compañía.',
    GREETINGS: 'Buen día, {{name}}',

    TITLE_1_MOBILE: 'Hola',

    CARDS_ENROLLED_COURSES_TITLE: 'Cursos inscritos',
    CARDS_ENROLLED_COURSES_DESCRIPTION:
      'Ingresa a los cursos que tienes asignados y continua con tu desarrollo.',
    CARDS_ENROLLED_COURSES_CTA: 'Ver mis cursos',
    CARDS_LEARNING_PATHS_TITLE: 'Rutas de aprendizaje',
    CARDS_LEARNING_PATHS_DESCRIPTION:
      'Potencia tus habilidades con contenido especializado y planificado para ti.',
    CARDS_LEARNING_PATHS_CTA: 'Ver mis rutas',

    PROFILE_CARD_VIEW_PROFILE: 'Ver perfil',
    PROFILE_CARD_OCCUPATION: 'Cargo',
    PROFILE_CARD_DEPARTMENT: 'Departamento',
    PROFILE_CARD_BOSS: 'Jefe',
    PROFILE_CARD_LOCATION: 'Sede',

    TALENT_CARD_TITLE: 'Procesos de Talento',
    TALENT_CARD_TITLE_SHORT: 'Procesos de Talent',
    TALENT_CARD_DESCRIPTION:
      'Accede a guías y tutoriales para sacarle el máximo provecho a los cursos y funcionalidades de aprendizaje.',

    // Sidebar
    SIDEBAR_FOOTER_HELP: 'Ayuda',

    LABEL_SIDEBAR_ITEM_COMEBACK: 'Volver a mis productos',
    LABEL_SIDEBAR_ITEM_COMEBACK_SHORT: 'Volver',
    LABEL_SIDEBAR_ITEM_TITLE: 'E-Learning',
    LABEL_SIDEBAR_ITEM_START: 'Inicio',
    LABEL_SIDEBAR_ITEM_CONTENT_FOR_YOU: 'Más contenido',
    LABEL_SIDEBAR_ITEM_MY_COURSES: 'Mis cursos',
    LABEL_SIDEBAR_ITEM_MY_COURSES_SEPARATOR: 'APRENDIZAJE Y PROGRESO',
    LABEL_SIDEBAR_ITEM_MY_COURSES_ENROLLED: 'Cursos inscritos',
    LABEL_SIDEBAR_ITEM_MY_COURSES_ENROLLED_MOBILE: 'Cursos',
    LABEL_SIDEBAR_ITEM_MY_COURSES_SAVED: 'Cursos guardados',
    LABEL_SIDEBAR_ITEM_MY_COURSES_TRACKS: 'Rutas de aprendizaje',
    LABEL_SIDEBAR_ITEM_MY_COURSES_TRACKS_DETAIL: 'Rutas de aprendizaje de',
    LABEL_SIDEBAR_ITEM_MY_COURSES_SUBTITLE:
      'Explora tus rutas asignadas para un aprendizaje personalizado.',
    LABEL_SIDEBAR_ITEM_MY_COURSES_NOTES: 'Apuntes',
    LABEL_SIDEBAR_ITEM_MY_COURSES_CERTIFICATIONS: 'Diplomas',
    LABEL_SIDEBAR_ITEM_MY_PROJECTS: 'Proyectos',
    LABEL_SIDEBAR_ITEM_MY_STUDY_PLAN: 'Plan de estudios',
    LABEL_SIDEBAR_ITEM_SKILL_XP: 'Skill XP',
    LABEL_SIDEBAR_ITEM_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
    LABEL_SIDEBAR_ITEM_SKILL_XP_EVOLUTION_PENDING: 'Tests pendientes',
    LABEL_SIDEBAR_ITEM_SKILL_XP_EVOLUTION_SOLVED: 'Tests resueltos',
    LABEL_SIDEBAR_ITEM_SKILL_XP_SEPARATOR: 'EVALUACIÓN Y LOGROS',
    LABEL_SIDEBAR_ITEM_MENTORS: 'Mentorías',
    LABEL_SIDEBAR_ITEM_BLOG: 'Blog',
    LABEL_SIDEBAR_ITEM_LIVES: 'Lives',
    LABEL_SIDEBAR_ITEM_TOOLS: 'Herramientas',
    LABEL_SIDEBAR_ITEM_PLAYROOM_ACHIEVEMENTS: 'Logros',
    LABEL_SIDEBAR_ITEM_PLAYROOM_REWARDS: 'Recompensas',
    LABEL_SIDEBAR_ITEM_PLAYROOM_TAB: 'Gamificación',

    SOCIAL_HUB_CARD_TITLE: 'Noticias',
    SOCIAL_HUB_CARD_CTA: 'Leer noticia',
    SOCIAL_HUB_CARD_PUBLISH_DATE: 'Publicado el {{date}}',
    SOCIAL_HUB_CARD_EMPTY_TITLE: 'Pronto tu compañía publicará sus noticias',
    SOCIAL_HUB_CARD_EMPTY_DESCRIPTION:
      'Mientras tanto, inspírate con artículos relevantes para tu camino profesional.',
    SOCIAL_HUB_CARD_EMPTY_BUTTON: 'Ir al blog de Crehana',
    SOCIAL_HUB_CARD_ERROR_TITLE: 'Ocurrió un error en la carga',
    SOCIAL_HUB_CARD_ERROR_DESCRIPTION:
      'Haz clic en el botón para intentar cargar nuevamente.',
    SOCIAL_HUB_CARD_ERROR_CTA: 'Reintentar',

    LEARNING_CARD_TITLE: 'Continúa tu aprendizaje',

    // Widgets fetching errors
    ERROR_FETCHING_LEARNING_PATHS: 'Ocurrió un error en la carga',
    ERROR_FETCHING_COURSES: 'Ocurrió un error en la carga',
    ERROR_FETCHING_LAST_ACTIVITY: 'Ocurrió un error en la carga',
    GRID_WIDGETS_EMPTY_STATE_TITLE: 'No se pudo cargar el contenido',
    GRID_WIDGETS_EMPTY_STATE_DESCRIPTION:
      'Ocurrió un problema con la consulta o la configuración no es reconocida por alguna razón. Por favor, contacta a tu administrador o soporte técnico para revisar y resolver este problema',

    // Error widget translations
    ERROR_WIDGET_TITLE: 'Ocurrió un error',
    ERROR_WIDGET_MESSAGE:
      'Haz clic en el botón para reintentar cargar nuevamente.',
    ERROR_WIDGET_RETRY_BUTTON: 'Reintentar',

    TODO_LIST_ADMIN_WIDGET_TAB_MANAGEMENT: 'Gestión',
    TODO_LIST_ADMIN_WIDGET_TAB_ALL: 'Todas',
    USERS: 'Usuarios',
    SEARCH_USER_INPUT_PLACEHOLDER: 'Buscar',
    HOLIDAY_DETAIL_TABLE_COLUMN_NAME: 'Nombre',
    HOLIDAY_DETAIL_TABLE_COLUMN_JOB_CATEGORY: 'Cargo',
    HOLIDAY_DETAIL_TABLE_COLUMN_AREA: 'Área',
    HOLIDAY_DETAIL_TABLE_COLUMN_COUNTRY: 'País',
    HOLIDAY_DETAIL_MODAL_TITLE: 'Detalle de usuarios',
    HOLIDAY_DETAIL_MODAL_INFO:
      'Tus características de área, sede y país no cumplen con los requisitos para acceder a este feriado.',
    HOLIDAY_DETAIL_MODAL_TITLE_DESCRIPTION:
      'Visualiza aquí los usuarios que coinciden con la regla establecida para acceder a este feriado.',
    ERROR_LOADING_DAY_EVENTS: 'No se pudo cargar el contenido',
    ERROR_LOADING_DAY_EVENTS_DESCRIPTION:
      'Hubo un problema con la consulta. Por favor, inténtalo de nuevo más tarde.',
    GO_BACK: 'Volver',
    RETRY: 'Reintentar',
    DATE_PREPOSITION_DE: 'de',
    DATE_PREPOSITION_DEL: 'del',

    // Annual Impact Banner
    ANNUAL_IMPACT_BANNER_TITLE:
      'Descubre y reconoce lo que construiste en el 2025. Porque no solo fue trabajo, fue la huella que dejaste.',
    ANNUAL_IMPACT_BANNER_TITLE_MOBILE: 'Descubre tu impacto 2025',
    LABEL_ANNUAL_IMPACT_BANNER_BUTTON: 'Descubrir mi impacto',

    // Annual Potential Banner
    ANNUAL_POTENTIAL_BANNER_TITLE:
      '2026 es el momento de llevar todo lo que ya construiste a su siguiente nivel.',
    ANNUAL_POTENTIAL_BANNER_TITLE_MOBILE: '2026, tu siguiente nivel',

    LABEL_ANNUAL_POTENTIAL_BANNER_BUTTON: 'Desbloquear mi potencial',

    // ============ START TIME AND ATTENDANCE TRACKING CARD ============
    // It's an mvp so these keys should be removed later
    today: 'Hoy',
    check_in: 'Ingreso',
    lunch_break: 'Almuerzo',
    check_out: 'Salida',
    hours_worked: 'Horas trabajadas',
    to_register: 'Por registrar',
    exit: 'Salir',
    start_lunch_break: 'Iniciar almuerzo',
    end_lunch_break: 'Fin almuerzo',
    register_lunch_break_toast_title: 'Te has registrado correctamente',
    register_lunch_break_toast_description:
      'Ya puedes consultar los datos en tu tarjeta de asistencia.',
    register: 'Registro',
    day: 'Día',
    place_of_marking: 'Lugar de marcaje',
    register_time: 'Hora de registro',
    scheduled_time: 'Hora programada',
    delay: 'Retraso',
    early_exit_time: 'Tiempo anticipado',
    go_to_module: 'Ver módulo',
    // ============ END TIME AND ATTENDANCE TRACKING CARD ============

    // ============ START PAYROLL RECEIPTS WIDGET ============
    PAYROLL_WIDGET_TITLE: 'Recibos de nómina',
    PAYROLL_WIDGET_SUBTITLE: 'Visualiza y descarga tus recibos de pago',
    PAYROLL_NEXT_PAYMENT_LABEL: 'Fecha del próximo pago',
    PAYROLL_NEXT_PAYMENT_TOOLTIP:
      'Los tiempos del procesamiento bancario pueden afectar la llegada del pago.',
    PAYROLL_EMPTY_TITLE: 'Aún no tienes recibos emitidos en la plataforma',
    PAYROLL_EMPTY_DESCRIPTION:
      'Cuando tu compañía realice el pago de nómina, verás tu recibo aquí.',
    PAYROLL_PERIOD_LABEL: 'Período',
    PAYROLL_VIEW_RECEIPT: 'Ver recibo',
    PAYROLL_DOWNLOAD: 'Descargar',
    PAYROLL_DOWNLOAD_RECEIPT_TOOLTIP: 'Descargar recibo',
    PAYROLL_TOAST_DOWNLOAD_SUCCESS:
      'El recibo en formato PDF se ha descargado con éxito.',
    PAYROLL_TOAST_DOWNLOAD_ERROR:
      'Lo sentimos, se produjo un error al intentar ejecutar la descarga.',
    PAYROLL_TOAST_DOWNLOAD_ERROR_DESCRIPTION:
      'Por favor, intenta descargarlo nuevamente.',

    PAYROLL_ERROR_LOAD_TITLE: 'Ocurrió un error',
    PAYROLL_ERROR_LOAD_DESCRIPTION:
      'Haz clic en el botón para reintentar cargar nuevamente.',
    PAYROLL_RETRY: 'Reintentar',

    PAYROLL_MODAL_RECEIPT_TITLE_1: 'Recibo:',
    PAYROLL_MODAL_RECEIPT_TITLE_2:
      'Período {{periodNumber}} del {{start}} al {{end}} de {{month}} del {{year}}',
    PAYROLL_MODAL_ERROR_MESSAGE: 'Ocurrió un error',
    PAYROLL_MODAL_ERROR_DESCRIPTION:
      'Haz clic en el botón para reintentar cargar nuevamente.',
    PAYROLL_MODAL_RETRY: 'Reintentar',
    PAYROLL_CONTACT_SUPPORT:
      'Si el problema persiste, contacta a soporte técnico.',
    // ============ END PAYROLL RECEIPTS WIDGET ============
  },
};

export default es;
